import { render, staticRenderFns } from "./ViewImage.vue?vue&type=template&id=c6679abc&scoped=true&"
import script from "./ViewImage.vue?vue&type=script&lang=js&"
export * from "./ViewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6679abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6679abc')) {
      api.createRecord('c6679abc', component.options)
    } else {
      api.reload('c6679abc', component.options)
    }
    module.hot.accept("./ViewImage.vue?vue&type=template&id=c6679abc&scoped=true&", function () {
      api.rerender('c6679abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/mixins/ViewImage.vue"
export default component.exports